import request from "@/utils/request";

export function getGrcActionPlans(params) {
  return request({
    url: "/grc-action-plans",
    method: "get",
    params,
  });
}

export function getGrcActionPlan(id, params) {
  return request({
    url: `/grc-action-plans/${id}`,
    method: "get",
    params,
  });
}

export function createGrcActionPlan(data, params) {
  return request({
    url: "/grc-action-plans",
    method: "post",
    data,
    params,
  });
}

export function updateGrcActionPlan(id, data, params) {
  return request({
    url: `/grc-action-plans/${id}`,
    method: "put",
    data,
    params,
  });
}

export function approveGrcActionPlan(id, data, params) {
  return request({
    url: `/grc-action-plans/${id}/approve`,
    method: "post",
    data,
    params,
  });
}

export function rejectGrcActionPlan(id, data, params) {
  return request({
    url: `/grc-action-plans/${id}/reject`,
    method: "post",
    data,
    params,
  });
}

export function deleteGrcActionPlan(id, params) {
  return request({
    url: `/grc-action-plans/${id}`,
    method: "delete",
    params,
  });
}
